/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface TradingPlatformInfo
 */
export class TradingPlatformInfo {
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    id?: string;
    /**
     *
     * @type {number}
     * @memberof TradingPlatformInfo
     */
    leverage?: number;
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    name?: string | null;
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    type?: TradingPlatformInfoTypeEnum;
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    webTraderEnvId?: string | null;
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    webTraderUrl?: string | null;
    /**
     *
     * @type {string}
     * @memberof TradingPlatformInfo
     */
    webTraderUrlForMobile?: string | null;
}

/**
 * @export
 * @enum {string}
 */
export enum TradingPlatformInfoTypeEnum {
    Demo = 'Demo',
    Real = 'Real',
}
